import React from 'react'
import styled, { keyframes } from 'styled-components';
import { getLocalImage } from '../../helpers/getLocalImages';
import { Wrapper } from '../ui/Wrapper/Wrapper';

const anmLoop = keyframes`
    100% {
        transform: translateX(-109%);
    }
`;

const WrapperLoopText = styled(Wrapper)`
    padding: 40px 0;
    @media ${({theme}) => theme.mediaQueries.breakpointMd}{
        padding: 20px 0;
    }
`;

const Ul = styled('ul')`
    padding: 0;
    width: 100%;
    height: 360px;
    overflow: hidden;
    display: flex;
    align-items: center;
    position: relative;
    @media ${({theme}) => theme.mediaQueries.breakpointMd}{
        height: 180px;
    }
`;

const List = styled('li')`
    width: 105%;
    padding: 35px 0px;
    border-top: 1px solid ${({theme}) => theme.colors.grey};
    border-bottom: 1px solid ${({theme}) => theme.colors.grey};
    background: ${({theme}) => theme.colors.dark};
    white-space: nowrap;
    position: absolute;
    box-shadow: 0px 10px 30px rgba(0,0,0,.2);
    @media ${({theme}) => theme.mediaQueries.breakpointMd} {
     padding: 20px 0px;   
    }
    &:first-child{
        transform: rotate(-5deg);
        @media ${({theme}) => theme.mediaQueries.breakpointMd}{
            transform: rotate(-6deg);
        }
    }
    &:first-child{
        transform: rotate(6deg);
        @media ${({theme}) => theme.mediaQueries.breakpointMd}{
            transform: rotate(10deg);
        }
    }
    span {
        display: inline-block;
        white-space: nowrap;
        color: #fff;
        font-size: 2em;
        margin-right: 20px;
        font-weight: 700;
        animation: ${anmLoop} 3s linear infinite;
        img {
            max-width: 25px;
        }
    }
`;

const TextLoop = () => {
    return (
        <WrapperLoopText width='100%'>
            <Ul>
                {renderTextLoop()}
                {renderTextLoop()}
            </Ul>
        </WrapperLoopText>
    );

    function renderTextLoop(){
        const text = Array.apply(0, Array(40)).map( (x, i) => (
            <span key={i} className='txt-inner-loop'>la nostra rubrica <img src={getLocalImage('coffee.png')} alt='coffee yq'/></span>
        ))
        return <List key={Math.random()}>{text}</List>
    }
}

export default TextLoop;
